import {ComplectationBlock, OptionAttribute, OptionsSelected} from "../data";

export const isPinsBlockId = (sectionId: string) => {
    return sectionId === 'piny';
}

/**
 * Generates unique hash string of given length
 *
 */
export const generateHash = (len: number = 16) => {
    const dec2hex = (dec: number) => dec.toString(16).padStart(2, "0");

    const arr = new Uint8Array((len || 40) / 2);

    window.crypto.getRandomValues(arr);

    return Array.from(arr, dec2hex).join('');
}

/**
 * Creates a UID string which looks like "first:second:third"
 * contains unlimited list of string arguments
 */
export const generateUid = (...args: string[]) => {
    return args.join(':');
}

export const splitUid = (uid: string) => {
    return uid.split(':').filter(Boolean);
}

export const toggleObjectProp = <TObject extends Object>(obj: TObject, key: keyof TObject, value: any = '') => {
    const data = {...obj};

    if (data.hasOwnProperty(key)) {
        delete data[key];
    } else {
        data[key] = value;
    }

    return data;
}

/**
 * Creates an empty array of given length
 * and fill it with null values
 *
 * @param length
 */
export const createEmptyArrayByLength = (length: number) => {
    return Array(length).fill(null);
}


/**
 * Returns an ID of selected slot with the same value as been passed to function
 */
export const getUsedSlotId = (
    selectedOptions: OptionsSelected,
    slotsCount: number,
    uid: string,
    value: OptionAttribute | null
): string | null => {

    let result = null;

    createEmptyArrayByLength(slotsCount).every((el, index) => {
        const id = generateUid(uid, String(index));

        const slot = selectedOptions[id];

        if (slot && slot.id === value?.id) {
            result = id;

            return false;
        }

        return true;
    });

    return result;
};


/**
 * Returns an ID of first empty slot
 */
export const getEmptySlotId = (
    selectedOptions: OptionsSelected,
    slotsCount: number,
    uid: string
): string | null => {

    let result = null;

    createEmptyArrayByLength(slotsCount).every((el, index) => {
        const id = generateUid(uid, String(index));

        const slot = selectedOptions[id];
        const isEmpty = !slot || !Object.keys(slot).length;

        if (!slot || isEmpty) {
            result = id;

            return false;
        }

        return true;
    });

    return result;
}

export const findSelectedByBlock = (blockId: string, selected: OptionsSelected) => {
    return Object.keys(selected).reduce<OptionsSelected>((total, current) => {
        if (current.startsWith(`${blockId}:`)) {
            total[current] = selected[current];
        }

        return total;
    }, {})
}


export const findBlockItemBySelected = (block: ComplectationBlock, selected: OptionsSelected) => {
    const selectedByBlock = findSelectedByBlock(block.id, selected);

    return block.items.find(item => {
        const itemKeys = Object.keys(item.attributes);

        return itemKeys.every(key => item.attributes[key].id === selectedByBlock[generateUid(block.id, key)]?.id)
    });
}

/**
 * В данной функции допускается, что товары со слотами имеют всегда один атрибут
 * Если будет больше чем 1, то потребуется изменить функцию (фильтрация элементов)
 *
 */
export const findBlockItemWithSlotsBySelected = (block: ComplectationBlock, selected: OptionsSelected) => {
    const selectedByBlock = findSelectedByBlock(block.id, selected);
    const selectedByBlockValues = Object.values(selectedByBlock);

    if (!block.slots || !block.slots.positions.length) {
        return [];
    }

    return block.items.filter((item) => {
        const attribute = Object.values(item.attributes)[0];

        return selectedByBlockValues.some((selectedValue) => selectedValue?.id === attribute.id);
    });
}

export const doScrolling = async (positionY: number, duration: number, cb?: () => void) => {
    window.scroll({
        top: positionY,
        left: 0,
    });

    cb && setTimeout(cb);
}


export const getBlocksWithoutSlots = (blocks: ComplectationBlock[]) => {
    return blocks.filter(block => !block.slots || !block.slots.positions.length);
}

export const getBlocksWithSlots = (blocks: ComplectationBlock[]) => {
    return blocks.filter(block => block.slots && block.slots.positions.length);
}


/**
 * Generates a random number between given min and max (including them)
 */
export const randomBetween = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}
